// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Breathing animation for buttons */
@keyframes ApiConfigGB_breathe__arLme {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
}

/* Breathing animation with glow for buttons */
@keyframes ApiConfigGB_breatheWithGlow__iSAI5 {
  0% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
  50% {
    transform: scale(1.03);
    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  }
}

@keyframes ApiConfigGB_pulseGlow__tjQQU {
  0% {
    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0.4);
  }
  70% {
    box-shadow: 0 0 0 10px rgba(163, 112, 206, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0);
  }
}

/* Combined animation for Infer button */
.ApiConfigGB_inferButton__T\\+V\\+f:not(:disabled).ApiConfigGB_isReady__w32RV {
  animation:
    ApiConfigGB_breathe__arLme 2s ease-in-out infinite,
    ApiConfigGB_pulseGlow__tjQQU 2s ease-in-out infinite;
}

/* Combined animation for Import button (from CurlImporter) */
.ApiConfigGB_importButton__aeaKp:not(:disabled).ApiConfigGB_isImportReady__UX-70 {
  animation:
    ApiConfigGB_breathe__arLme 2s ease-in-out infinite,
    ApiConfigGB_pulseGlow__tjQQU 2s ease-in-out infinite;
}

/* Base button styles (if not already defined) */
.ApiConfigGB_inferButton__T\\+V\\+f {
  background: var(--editBtn);
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 12px;
  font-size: 0.813rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);
  position: relative;
  overflow: hidden;
}

.ApiConfigGB_inferButton__T\\+V\\+f:disabled {
  background: #dadce0;
  cursor: not-allowed;
  opacity: 0.6;
  color: #5f6368;
  animation: none !important;
}

.ApiConfigGB_inferButton__T\\+V\\+f:not(:disabled):hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(163, 112, 206, 0.35);
}

.ApiConfigGB_inferButtonContainer__kKYJG {
  margin-top: 16px;
  display: flex;
  justify-content: flex-end;
}

/* SampleDataEditor.module.css - Complete Updated Version */

.ApiConfigGB_container__DEkkt {
  /* margin-top: 15px; */
  padding: 20px;
  background: var(
    --white-color,
    linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)
  );
  border-radius: 16px;
  border: 1px solid rgba(163, 112, 206, 0.15);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: var(--cardBox-shadow, 0 2px 8px rgba(0, 0, 0, 0.08));
  position: relative;
  overflow: hidden;
}

.ApiConfigGB_container__DEkkt::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: var(
    --primary-gradient,
    linear-gradient(45deg, rgb(173, 117, 220), rgba(70, 101, 178, 80%))
  );
  opacity: 0.8;
}

.ApiConfigGB_container__DEkkt:hover {
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

/* ─── Tabs ─── */
.ApiConfigGB_tabs__Qnc5h {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 2rem;
  padding: 0.5rem;
  background: #e8ecf1;
  border-radius: 14px;
  border: 1px solid #d5dae0;
  position: relative;
  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);
}

.ApiConfigGB_tab__jZJV2 {
  flex: 1 1;
  padding: 0.75rem 1.5rem;
  background: transparent;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  font-size: 0.9rem;
  font-weight: 600;
  color: #4a5568;
  transition: all 0.3s ease;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  letter-spacing: 0.01em;
  white-space: nowrap;
}

.ApiConfigGB_tab__jZJV2:hover:not(.ApiConfigGB_activeTab__beAeX) {
  background: rgba(55, 151, 254, 0.08);
  color: #2d3748;
}

.ApiConfigGB_activeTab__beAeX {
  background: #ffffff;
  color: #1a202c;
  box-shadow:
    0 2px 12px rgba(0, 0, 0, 0.1),
    0 1px 3px rgba(0, 0, 0, 0.06);
  font-weight: 700;
}

.ApiConfigGB_activeTab__beAeX::before {
  content: "";
  position: absolute;
  inset: -1px;
  border-radius: 10px;
  background: linear-gradient(
    135deg,
    rgba(55, 151, 254, 0.15),
    rgba(163, 112, 206, 0.15)
  );
  z-index: -1;
  opacity: 0.8;
}

.ApiConfigGB_tab__jZJV2 .ApiConfigGB_tabIcon__gUT43 {
  font-size: 1.1rem;
  transition: transform 0.3s ease;
}

.ApiConfigGB_tab__jZJV2:hover:not(.ApiConfigGB_activeTab__beAeX) .ApiConfigGB_tabIcon__gUT43 {
  transform: scale(1.1) rotate(-5deg);
}

.ApiConfigGB_activeTab__beAeX .ApiConfigGB_tabIcon__gUT43 {
  transform: scale(1.1);
}

.ApiConfigGB_tabDivider__z4p1T {
  width: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 0.3rem 0;
}

/* ─── Form Groups ─── */
.ApiConfigGB_formGroup__osW68 {
  margin-top: 1.5rem;
  position: relative;
}

.ApiConfigGB_formGroup__osW68:last-of-type {
  margin-bottom: 1rem;
}
.ApiConfigGB_sampleWrap__icDVw {
  display: flex;
  gap: 10px;
  padding: 10px;
  border-radius: 10px;
  align-items: center;
  justify-content: space-between;
  box-shadow:
    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,
    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;
}
.ApiConfigGB_label__w0cX4 {
  display: flex;
  flex-direction: column;
  font-weight: 600;
  color: var(--dark-color, #1e1e1e);
  font-size: 0.9rem;
  letter-spacing: 0.3px;
  gap: 0.5rem;
}

.ApiConfigGB_label__w0cX4 strong {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-weight: 500;
  color: var(--dark2-color, #110f0f);
  font-size: 0.85rem;
  /* justify-content: center; */
  text-align: left;
}

.ApiConfigGB_label__w0cX4 small {
  font-size: 0.75rem;
  color: var(--text-color, #6b6b6b);
  margin-top: 0.25rem;
  font-weight: 400;
}

/* ─── Select Wrapper ─── */
.ApiConfigGB_selectWrapper__VPZ-X {
  position: relative;
  display: inline-block;
  width: 100%;
}

.ApiConfigGB_selectWrapperSmall__ELUJD {
  position: relative;
  display: inline-block;
  width: 140px;
  flex-shrink: 0;
}

/* ─── Custom Select ─── */
.ApiConfigGB_customSelect__mhMIR {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  padding-right: 40px !important;
  cursor: pointer;
  width: 100%;
}

.ApiConfigGB_customSelect__mhMIR::-ms-expand {
  display: none;
}

.ApiConfigGB_customSelect__mhMIR:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

/* ─── Select Icon ─── */
.ApiConfigGB_selectIcon__bZr8G {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
  font-size: 14px;
  transition: all 0.3s ease;
  z-index: 2;
}

.ApiConfigGB_selectIconSmall__4HUr9 {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  color: #666;
  font-size: 12px;
  transition: all 0.3s ease;
  z-index: 2;
}

/* ─── Rotate Icon on Hover ─── */
.ApiConfigGB_selectWrapper__VPZ-X:hover .ApiConfigGB_selectIcon__bZr8G,
.ApiConfigGB_selectWrapperSmall__ELUJD:hover .ApiConfigGB_selectIconSmall__4HUr9 {
  color: var(--editBtn, #3797fe);
  transform: translateY(-50%) rotate(180deg);
}

.ApiConfigGB_selectWrapper__VPZ-X:focus-within .ApiConfigGB_selectIcon__bZr8G,
.ApiConfigGB_selectWrapperSmall__ELUJD:focus-within .ApiConfigGB_selectIconSmall__4HUr9 {
  color: var(--editBtn, #3797fe);
  transform: translateY(-50%) rotate(180deg);
}

/* ─── Select Base Styles ─── */
.ApiConfigGB_select__c4cor {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e8eaed;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: var(--white-color);
  color: var(--dark-color, #1e1e1e);
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  cursor: pointer;
}

.ApiConfigGB_select__c4cor:focus {
  outline: none;
  border-color: var(--editBtn);
  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);
  transform: translateY(-1px);
}

.ApiConfigGB_select__c4cor:hover {
  border-color: var(--editBtn);
}

.ApiConfigGB_select__c4cor:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

/* ─── Input Styles ─── */
.ApiConfigGB_input__F-Mlw,
.ApiConfigGB_textarea__7IRDp,
.ApiConfigGB_statusInput__vM4Mu {
  width: 100%;
  padding: 10px 14px;
  border: 2px solid #e8eaed;
  border-radius: 10px;
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: var(--white-color);
  color: var(--dark-color, #1e1e1e);
}

.ApiConfigGB_input__F-Mlw:focus,
.ApiConfigGB_textarea__7IRDp:focus,
.ApiConfigGB_statusInput__vM4Mu:focus {
  outline: none;
  border-color: var(--editBtn);
  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);
  transform: translateY(-1px);
}

.ApiConfigGB_input__F-Mlw:hover,
.ApiConfigGB_textarea__7IRDp:hover,
.ApiConfigGB_statusInput__vM4Mu:hover {
  border-color: var(--editBtn);
}

.ApiConfigGB_input__F-Mlw:disabled,
.ApiConfigGB_textarea__7IRDp:disabled,
.ApiConfigGB_statusInput__vM4Mu:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

.ApiConfigGB_textarea__7IRDp {
  resize: vertical;
  min-height: 100px;
  max-height: 400px;
  font-family: "Fira Code", "Courier New", monospace;
  font-size: 0.9rem;
  line-height: 1.6;
  padding: 10px 14px;
  border: 2px solid #e8eaed;
  border-radius: 10px;
  transition: all 0.3s ease;
  background: var(--white-color);
  color: var(--dark-color, #1e1e1e);
  width: 100%;
  overflow-y: auto;
}

.ApiConfigGB_textarea__7IRDp::placeholder {
  color: rgb(18, 16, 16);
  opacity: 0.7;
  font-weight: 400;
}

.ApiConfigGB_input__F-Mlw::placeholder,
.ApiConfigGB_statusInput__vM4Mu::placeholder {
  color: rgb(18, 16, 16);
  opacity: 0.8;
}

.ApiConfigGB_textarea__7IRDp:focus::placeholder,
.ApiConfigGB_input__F-Mlw:focus::placeholder,
.ApiConfigGB_statusInput__vM4Mu:focus::placeholder {
  opacity: 0.4;
  transition: all 0.3s ease;
}

/* ─── Items Container ─── */
.ApiConfigGB_itemsContainer__fw7iH {
  /* margin-top: 0.75rem; */
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.ApiConfigGB_itemRow__AmKO7 {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  padding: 8px 12px;
  background: #e8f3ff;
  border-radius: 10px;
  border: 1px solid rgba(163, 112, 206, 0.08);
  transition: all 0.3s ease;
  animation: ApiConfigGB_slideIn__gOa1B 0.3s ease;
}

.ApiConfigGB_itemRow__AmKO7:hover {
  background: #c5e1ff;
}

.ApiConfigGB_itemInput__6uKEg {
  flex: 1 1;
  padding: 8px 12px;
  border: 2px solid #e8eaed;
  border-radius: 8px;
  font-size: 0.9rem;
  transition: all 0.3s ease;
  background: white;
}

.ApiConfigGB_itemInput__6uKEg:focus {
  outline: none;
  border-color: var(--editBtn);
  box-shadow: 0 0 0 3px rgba(163, 112, 206, 0.1);
}

.ApiConfigGB_itemInput__6uKEg:disabled {
  background: #f5f5f5;
  cursor: not-allowed;
  opacity: 0.7;
}

/* ─── Remove Button ─── */
.ApiConfigGB_removeButton__B5HQp {
  border: none;
  cursor: pointer;
  background: var(--deleteBtn, #ff485b);
  padding: 6px;
  border-radius: 50%;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  min-height: 28px;
  color: var(--white-color, #fff);
}

.ApiConfigGB_removeButton__B5HQp:hover:not(:disabled) {
  background: var(--deleteHover, #c82333);
  transform: scale(1.05);
}

.ApiConfigGB_removeButton__B5HQp:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  background: #f1f3f4;
  color: #9aa0a6;
}

/* ─── Add Button ─── */
.ApiConfigGB_addButton__MZo7v {
  background: transparent;
  /* border: 2px dashed var(--editBtn, #3797fe); */
  /* padding: 10px 16px; */
  /* border-radius: 10px; */
  cursor: pointer;
  color: var(--editBtn, #3797fe);
  font-weight: 500;
  transition: all 0.3s ease;
  display: inline-flex;
  align-items: center;
  /* gap: 0.5rem; */
  font-size: 0.9rem;
  /* margin: auto; */
  /* margin-top: 0.5rem; */
  justify-content: center;
  /* min-width: 300px; */
  border: none;
}

.ApiConfigGB_addButton__MZo7v:hover:not(:disabled) {
  transform: translateY(-2px);
}

.ApiConfigGB_addButton__MZo7v:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none !important;
  background: #f1f3f4;
  color: #9aa0a6;
  border-color: #dadce0;
}

/* ─── Sample Row ─── */
.ApiConfigGB_sampleRow__TtUaF {
  margin-top: 1rem;
  padding: 16px;
  background: rgba(126, 112, 206, 0.116);
  border-radius: 12px;
  border: 1px solid rgba(163, 112, 206, 0.08);
  transition: all 0.3s ease;
  animation: ApiConfigGB_slideIn__gOa1B 0.3s ease;
}

.ApiConfigGB_sampleRow__TtUaF:hover {
  background: rgba(163, 112, 206, 0.06);
  border-color: rgba(163, 112, 206, 0.15);
}

.ApiConfigGB_sampleStatusGroup__pkkgE {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.75rem;
}

.ApiConfigGB_sampleStatusGroup__pkkgE .ApiConfigGB_statusInput__vM4Mu {
  width: 120px;
  flex: none;
}

.ApiConfigGB_sampleStatusGroup__pkkgE .ApiConfigGB_removeButton__B5HQp {
  margin-left: auto;
}

/* ─── Infer Button ─── */
.ApiConfigGB_inferButtonContainer__kKYJG {
  display: flex;
  justify-content: center;
}

.ApiConfigGB_inferButton__T\\+V\\+f {
  background: var(--editBtn, #3797fe);
  color: white;
  padding: 14px 20px;
  border: none;
  border-radius: 12px;
  font-weight: 500;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  display: inline-flex;
  align-items: center;
  gap: 0.75rem;
  box-shadow: 0 4px 16px rgba(55, 151, 254, 0.25);
  position: relative;
  overflow: hidden;
}

.ApiConfigGB_inferButton__T\\+V\\+f::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}

.ApiConfigGB_inferButton__T\\+V\\+f:hover:not(:disabled)::before {
  left: 100%;
}

.ApiConfigGB_inferButton__T\\+V\\+f:active:not(:disabled) {
  transform: translateY(0) scale(0.98);
}

.ApiConfigGB_inferButton__T\\+V\\+f:disabled {
  opacity: 0.5;
  cursor: not-allowed;
  transform: none !important;
}

/* ─── Animations ─── */
@keyframes ApiConfigGB_slideIn__gOa1B {
  from {
    opacity: 0;
    transform: translateX(-10px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@keyframes ApiConfigGB_pulse__bnPLb {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.7;
  }
}

@keyframes ApiConfigGB_spin__jGKJd {
  to {
    transform: rotate(360deg);
  }
}

/* ─── Responsive ─── */
@media (max-width: 768px) {
  .ApiConfigGB_container__DEkkt {
    padding: 16px;
    border-radius: 12px;
  }

  .ApiConfigGB_tabs__Qnc5h {
    flex-wrap: wrap;
    padding: 0.35rem;
    gap: 0.25rem;
  }

  .ApiConfigGB_tab__jZJV2 {
    padding: 0.6rem 0.8rem;
    font-size: 0.8rem;
    flex: 1 1 auto;
    min-width: 80px;
    gap: 0.35rem;
  }

  .ApiConfigGB_tab__jZJV2 .ApiConfigGB_tabIcon__gUT43 {
    font-size: 0.95rem;
  }

  .ApiConfigGB_tabDivider__z4p1T {
    display: none;
  }

  .ApiConfigGB_itemRow__AmKO7 {
    flex-wrap: wrap;
    padding: 12px;
    flex-direction: column;
  }

  .ApiConfigGB_itemInput__6uKEg {
    flex: 1 1 100%;
    min-width: 0;
  }

  .ApiConfigGB_sampleStatusGroup__pkkgE {
    flex-wrap: wrap;
  }

  .ApiConfigGB_sampleStatusGroup__pkkgE .ApiConfigGB_select__c4cor,
  .ApiConfigGB_sampleStatusGroup__pkkgE .ApiConfigGB_statusInput__vM4Mu {
    width: 100%;
  }

  .ApiConfigGB_selectWrapperSmall__ELUJD {
    width: 100%;
  }

  .ApiConfigGB_inferButton__T\\+V\\+f {
    width: 100%;
    justify-content: center;
    padding: 12px 20px;
    font-size: 0.95rem;
  }

  .ApiConfigGB_addButton__MZo7v {
    width: 100%;
    justify-content: center;
    min-width: auto;
  }
    .ApiConfigGB_sampleWrap__icDVw{
    flex-direction: column;
  }
  .ApiConfigGB_sampleRow__TtUaF{
    padding: 10px;
  }
}

@media (max-width: 480px) {
  .ApiConfigGB_tabs__Qnc5h {
    flex-direction: column;
    gap: 0.25rem;
    padding: 0.25rem;
  }

  .ApiConfigGB_tab__jZJV2 {
    padding: 0.5rem 1rem;
    justify-content: center;
    width: 100%;
    font-size: 0.75rem;
  }

  .ApiConfigGB_tab__jZJV2 .ApiConfigGB_tabLabel__oz9MM {
    font-size: 0.8rem;
  }
    .ApiConfigGB_sampleWrap__icDVw{
    flex-direction: column;
  }
}

/* ─── Scrollbar ─── */
.ApiConfigGB_textarea__7IRDp::-webkit-scrollbar {
  width: 8px;
}

.ApiConfigGB_textarea__7IRDp::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.ApiConfigGB_textarea__7IRDp::-webkit-scrollbar-thumb {
  background: var(--editBtn, #3797fe);
  border-radius: 4px;
}

.ApiConfigGB_textarea__7IRDp::-webkit-scrollbar-thumb:hover {
  background: var(--editHover, #0056b3);
}

/* ─── Focus Visible ─── */
.ApiConfigGB_input__F-Mlw:focus-visible,
.ApiConfigGB_select__c4cor:focus-visible,
.ApiConfigGB_textarea__7IRDp:focus-visible,
.ApiConfigGB_statusInput__vM4Mu:focus-visible,
.ApiConfigGB_itemInput__6uKEg:focus-visible,
.ApiConfigGB_addButton__MZo7v:focus-visible,
.ApiConfigGB_removeButton__B5HQp:focus-visible,
.ApiConfigGB_inferButton__T\\+V\\+f:focus-visible,
.ApiConfigGB_tab__jZJV2:focus-visible {
  outline-offset: 2px;
}

/* ─── Loading State ─── */
.ApiConfigGB_inferButton__T\\+V\\+f.ApiConfigGB_loading__auUR7 {
  position: relative;
  color: transparent;
}

.ApiConfigGB_inferButton__T\\+V\\+f.ApiConfigGB_loading__auUR7::after {
  content: "";
  position: absolute;
  width: 20px;
  height: 20px;
  border: 3px solid rgba(255, 255, 255, 0.3);
  border-top-color: var(--white-color);
  border-radius: 50%;
  animation: ApiConfigGB_spin__jGKJd 0.8s linear infinite;
}

/* ─── Helper Text ─── */
.ApiConfigGB_helperText__0xKtk {
  font-size: 0.8rem;
  color: var(--text-color, #6b6b6b);
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.25rem;
}

/* ─── Badges ─── */
.ApiConfigGB_requiredBadge__--L56 {
  display: inline-block;
  background: rgba(220, 53, 69, 0.1);
  color: #dc3545;
  font-size: 0.7rem;
  padding: 2px 8px;
  border-radius: 12px;
  font-weight: 600;
  margin-left: 0.5rem;
}

.ApiConfigGB_statusIndicator__3L2\\+B {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  margin-right: 8px;
  animation: ApiConfigGB_pulse__bnPLb 2s infinite;
}

.ApiConfigGB_statusIndicator__3L2\\+B.ApiConfigGB_active__F-7g9 {
  background: #28a745;
}

.ApiConfigGB_statusIndicator__3L2\\+B.ApiConfigGB_inactive__6o7R- {
  background: #dc3545;
}

.ApiConfigGB_statusIndicator__3L2\\+B.ApiConfigGB_pending__RgZhm {
  background: #ff9800;
}

/* ─── Glass Effect ─── */
.ApiConfigGB_glassEffect__kywYd {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
}
`, "",{"version":3,"sources":["webpack://./src/Component/SideData/Overview/AiAgentWorkFlow/ApiConfigGB.module.css"],"names":[],"mappings":"AAAA,oCAAoC;AACpC;EACE;IACE,mBAAmB;IACnB,gDAAgD;EAClD;EACA;IACE,sBAAsB;IACtB,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA,8CAA8C;AAC9C;EACE;IACE,mBAAmB;IACnB,gDAAgD;EAClD;EACA;IACE,sBAAsB;IACtB,gDAAgD;EAClD;EACA;IACE,mBAAmB;IACnB,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,4CAA4C;EAC9C;EACA;IACE,6CAA6C;EAC/C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA,wCAAwC;AACxC;EACE;;wDAEmC;AACrC;;AAEA,6DAA6D;AAC7D;EACE;;wDAEmC;AACrC;;AAEA,gDAAgD;AAChD;EACE,0BAA0B;EAC1B,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;EAC3B,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA,2DAA2D;;AAE3D;EACE,sBAAsB;EACtB,aAAa;EACb;;;GAGC;EACD,mBAAmB;EACnB,2CAA2C;EAC3C,iDAAiD;EACjD,gEAAgE;EAChE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX;;;GAGC;EACD,YAAY;AACd;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,+CAA+C;AACjD;;AAEA;EACE,SAAO;EACP,uBAAuB;EACvB,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd;;iCAE+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB;;;;GAIC;EACD,WAAW;EACX,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,UAAU;EACV,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;EAC9B;;0CAEwC;AAC1C;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iCAAiC;EACjC,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kCAAkC;EAClC,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,iCAAiC;EACjC,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,2BAA2B;AAC3B;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,YAAY;EACZ,cAAc;AAChB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,oBAAoB;EACpB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,UAAU;AACZ;;AAEA,iCAAiC;AACjC;;EAEE,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA;;EAEE,8BAA8B;EAC9B,0CAA0C;AAC5C;;AAEA,+BAA+B;AAC/B;EACE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,yBAAyB;AACzB;;;EAGE,WAAW;EACX,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;AACnC;;AAEA;;;EAGE,aAAa;EACb,4BAA4B;EAC5B,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;;;EAGE,4BAA4B;AAC9B;;AAEA;;;EAGE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,kDAAkD;EAClD,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,iCAAiC;EACjC,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,YAAY;AACd;;AAEA;;;EAGE,YAAY;EACZ,yBAAyB;AAC3B;;AAEA,4BAA4B;AAC5B;EACE,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,+CAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,4BAA4B;EAC5B,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA,0BAA0B;AAC1B;EACE,YAAY;EACZ,eAAe;EACf,qCAAqC;EACrC,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,uCAAuC;EACvC,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,uBAAuB;EACvB,gDAAgD;EAChD,wBAAwB;EACxB,yBAAyB;EACzB,eAAe;EACf,8BAA8B;EAC9B,gBAAgB;EAChB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,wBAAwB;EACxB,uBAAuB;EACvB,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;EAC1B,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,aAAa;EACb,sCAAsC;EACtC,mBAAmB;EACnB,2CAA2C;EAC3C,yBAAyB;EACzB,+CAA4B;AAC9B;;AAEA;EACE,qCAAqC;EACrC,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,UAAU;AACZ;;AAEA;EACE,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,iDAAiD;EACjD,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,+CAA+C;EAC/C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,WAAW;EACX,QAAQ;EACR,SAAS;EACT;;;;;GAKC;EACD,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,uBAAuB;AACvB;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,UAAU;EACZ;EACA;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,uBAAuB;AACvB;EACE;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,YAAY;EACd;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;IACf,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,cAAc;IACd,YAAY;EACd;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,uBAAuB;IACvB,eAAe;EACjB;IACE;IACA,sBAAsB;EACxB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;IACZ,gBAAgB;EAClB;;EAEA;IACE,oBAAoB;IACpB,uBAAuB;IACvB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;IACE;IACA,sBAAsB;EACxB;AACF;;AAEA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,kBAAkB;AACpB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,0BAA0B;AAC1B;;;;;;;;;EASE,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,oCAAoC;EACpC,kBAAkB;EAClB,uDAAoC;AACtC;;AAEA,wBAAwB;AACxB;EACE,iBAAiB;EACjB,iCAAiC;EACjC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,mBAAmB;AACnB;EACE,qBAAqB;EACrB,kCAAkC;EAClC,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,+CAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,yBAAyB;AACzB;EACE,oCAAoC;EACpC,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;AAC5C","sourcesContent":["/* Breathing animation for buttons */\n@keyframes breathe {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n  50% {\n    transform: scale(1.03);\n    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n}\n\n/* Breathing animation with glow for buttons */\n@keyframes breatheWithGlow {\n  0% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n  50% {\n    transform: scale(1.03);\n    box-shadow: 0 6px 24px rgba(163, 112, 206, 0.45);\n  }\n  100% {\n    transform: scale(1);\n    box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  }\n}\n\n@keyframes pulseGlow {\n  0% {\n    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0.4);\n  }\n  70% {\n    box-shadow: 0 0 0 10px rgba(163, 112, 206, 0);\n  }\n  100% {\n    box-shadow: 0 0 0 0 rgba(163, 112, 206, 0);\n  }\n}\n\n/* Combined animation for Infer button */\n.inferButton:not(:disabled).isReady {\n  animation:\n    breathe 2s ease-in-out infinite,\n    pulseGlow 2s ease-in-out infinite;\n}\n\n/* Combined animation for Import button (from CurlImporter) */\n.importButton:not(:disabled).isImportReady {\n  animation:\n    breathe 2s ease-in-out infinite,\n    pulseGlow 2s ease-in-out infinite;\n}\n\n/* Base button styles (if not already defined) */\n.inferButton {\n  background: var(--editBtn);\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 12px;\n  font-size: 0.813rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  box-shadow: 0 4px 16px rgba(163, 112, 206, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.inferButton:disabled {\n  background: #dadce0;\n  cursor: not-allowed;\n  opacity: 0.6;\n  color: #5f6368;\n  animation: none !important;\n}\n\n.inferButton:not(:disabled):hover {\n  transform: translateY(-2px);\n  box-shadow: 0 6px 20px rgba(163, 112, 206, 0.35);\n}\n\n.inferButtonContainer {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-end;\n}\n\n/* SampleDataEditor.module.css - Complete Updated Version */\n\n.container {\n  /* margin-top: 15px; */\n  padding: 20px;\n  background: var(\n    --white-color,\n    linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%)\n  );\n  border-radius: 16px;\n  border: 1px solid rgba(163, 112, 206, 0.15);\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  box-shadow: var(--cardBox-shadow, 0 2px 8px rgba(0, 0, 0, 0.08));\n  position: relative;\n  overflow: hidden;\n}\n\n.container::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  height: 4px;\n  background: var(\n    --primary-gradient,\n    linear-gradient(45deg, rgb(173, 117, 220), rgba(70, 101, 178, 80%))\n  );\n  opacity: 0.8;\n}\n\n.container:hover {\n  background: rgba(255, 255, 255, 0.85);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n/* ─── Tabs ─── */\n.tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 2rem;\n  padding: 0.5rem;\n  background: #e8ecf1;\n  border-radius: 14px;\n  border: 1px solid #d5dae0;\n  position: relative;\n  box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.tab {\n  flex: 1;\n  padding: 0.75rem 1.5rem;\n  background: transparent;\n  border: none;\n  border-radius: 10px;\n  cursor: pointer;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #4a5568;\n  transition: all 0.3s ease;\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  letter-spacing: 0.01em;\n  white-space: nowrap;\n}\n\n.tab:hover:not(.activeTab) {\n  background: rgba(55, 151, 254, 0.08);\n  color: #2d3748;\n}\n\n.activeTab {\n  background: #ffffff;\n  color: #1a202c;\n  box-shadow:\n    0 2px 12px rgba(0, 0, 0, 0.1),\n    0 1px 3px rgba(0, 0, 0, 0.06);\n  font-weight: 700;\n}\n\n.activeTab::before {\n  content: \"\";\n  position: absolute;\n  inset: -1px;\n  border-radius: 10px;\n  background: linear-gradient(\n    135deg,\n    rgba(55, 151, 254, 0.15),\n    rgba(163, 112, 206, 0.15)\n  );\n  z-index: -1;\n  opacity: 0.8;\n}\n\n.tab .tabIcon {\n  font-size: 1.1rem;\n  transition: transform 0.3s ease;\n}\n\n.tab:hover:not(.activeTab) .tabIcon {\n  transform: scale(1.1) rotate(-5deg);\n}\n\n.activeTab .tabIcon {\n  transform: scale(1.1);\n}\n\n.tabDivider {\n  width: 1px;\n  background: rgba(0, 0, 0, 0.1);\n  margin: 0.3rem 0;\n}\n\n/* ─── Form Groups ─── */\n.formGroup {\n  margin-top: 1.5rem;\n  position: relative;\n}\n\n.formGroup:last-of-type {\n  margin-bottom: 1rem;\n}\n.sampleWrap {\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n  border-radius: 10px;\n  align-items: center;\n  justify-content: space-between;\n  box-shadow:\n    rgba(0, 0, 0, 0.02) 0px 1px 3px 0px,\n    rgba(27, 31, 35, 0.15) 0px 0px 0px 1px;\n}\n.label {\n  display: flex;\n  flex-direction: column;\n  font-weight: 600;\n  color: var(--dark-color, #1e1e1e);\n  font-size: 0.9rem;\n  letter-spacing: 0.3px;\n  gap: 0.5rem;\n}\n\n.label strong {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-weight: 500;\n  color: var(--dark2-color, #110f0f);\n  font-size: 0.85rem;\n  /* justify-content: center; */\n  text-align: left;\n}\n\n.label small {\n  font-size: 0.75rem;\n  color: var(--text-color, #6b6b6b);\n  margin-top: 0.25rem;\n  font-weight: 400;\n}\n\n/* ─── Select Wrapper ─── */\n.selectWrapper {\n  position: relative;\n  display: inline-block;\n  width: 100%;\n}\n\n.selectWrapperSmall {\n  position: relative;\n  display: inline-block;\n  width: 140px;\n  flex-shrink: 0;\n}\n\n/* ─── Custom Select ─── */\n.customSelect {\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  padding-right: 40px !important;\n  cursor: pointer;\n  width: 100%;\n}\n\n.customSelect::-ms-expand {\n  display: none;\n}\n\n.customSelect:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ─── Select Icon ─── */\n.selectIcon {\n  position: absolute;\n  right: 14px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #666;\n  font-size: 14px;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n.selectIconSmall {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  pointer-events: none;\n  color: #666;\n  font-size: 12px;\n  transition: all 0.3s ease;\n  z-index: 2;\n}\n\n/* ─── Rotate Icon on Hover ─── */\n.selectWrapper:hover .selectIcon,\n.selectWrapperSmall:hover .selectIconSmall {\n  color: var(--editBtn, #3797fe);\n  transform: translateY(-50%) rotate(180deg);\n}\n\n.selectWrapper:focus-within .selectIcon,\n.selectWrapperSmall:focus-within .selectIconSmall {\n  color: var(--editBtn, #3797fe);\n  transform: translateY(-50%) rotate(180deg);\n}\n\n/* ─── Select Base Styles ─── */\n.select {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e8eaed;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: var(--white-color);\n  color: var(--dark-color, #1e1e1e);\n  appearance: none;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  cursor: pointer;\n}\n\n.select:focus {\n  outline: none;\n  border-color: var(--editBtn);\n  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);\n  transform: translateY(-1px);\n}\n\n.select:hover {\n  border-color: var(--editBtn);\n}\n\n.select:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ─── Input Styles ─── */\n.input,\n.textarea,\n.statusInput {\n  width: 100%;\n  padding: 10px 14px;\n  border: 2px solid #e8eaed;\n  border-radius: 10px;\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: var(--white-color);\n  color: var(--dark-color, #1e1e1e);\n}\n\n.input:focus,\n.textarea:focus,\n.statusInput:focus {\n  outline: none;\n  border-color: var(--editBtn);\n  box-shadow: 0 0 0 4px rgba(163, 112, 206, 0.1);\n  transform: translateY(-1px);\n}\n\n.input:hover,\n.textarea:hover,\n.statusInput:hover {\n  border-color: var(--editBtn);\n}\n\n.input:disabled,\n.textarea:disabled,\n.statusInput:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n  max-height: 400px;\n  font-family: \"Fira Code\", \"Courier New\", monospace;\n  font-size: 0.9rem;\n  line-height: 1.6;\n  padding: 10px 14px;\n  border: 2px solid #e8eaed;\n  border-radius: 10px;\n  transition: all 0.3s ease;\n  background: var(--white-color);\n  color: var(--dark-color, #1e1e1e);\n  width: 100%;\n  overflow-y: auto;\n}\n\n.textarea::placeholder {\n  color: rgb(18, 16, 16);\n  opacity: 0.7;\n  font-weight: 400;\n}\n\n.input::placeholder,\n.statusInput::placeholder {\n  color: rgb(18, 16, 16);\n  opacity: 0.8;\n}\n\n.textarea:focus::placeholder,\n.input:focus::placeholder,\n.statusInput:focus::placeholder {\n  opacity: 0.4;\n  transition: all 0.3s ease;\n}\n\n/* ─── Items Container ─── */\n.itemsContainer {\n  /* margin-top: 0.75rem; */\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.itemRow {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  padding: 8px 12px;\n  background: #e8f3ff;\n  border-radius: 10px;\n  border: 1px solid rgba(163, 112, 206, 0.08);\n  transition: all 0.3s ease;\n  animation: slideIn 0.3s ease;\n}\n\n.itemRow:hover {\n  background: #c5e1ff;\n}\n\n.itemInput {\n  flex: 1;\n  padding: 8px 12px;\n  border: 2px solid #e8eaed;\n  border-radius: 8px;\n  font-size: 0.9rem;\n  transition: all 0.3s ease;\n  background: white;\n}\n\n.itemInput:focus {\n  outline: none;\n  border-color: var(--editBtn);\n  box-shadow: 0 0 0 3px rgba(163, 112, 206, 0.1);\n}\n\n.itemInput:disabled {\n  background: #f5f5f5;\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n/* ─── Remove Button ─── */\n.removeButton {\n  border: none;\n  cursor: pointer;\n  background: var(--deleteBtn, #ff485b);\n  padding: 6px;\n  border-radius: 50%;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 28px;\n  min-height: 28px;\n  color: var(--white-color, #fff);\n}\n\n.removeButton:hover:not(:disabled) {\n  background: var(--deleteHover, #c82333);\n  transform: scale(1.05);\n}\n\n.removeButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  background: #f1f3f4;\n  color: #9aa0a6;\n}\n\n/* ─── Add Button ─── */\n.addButton {\n  background: transparent;\n  /* border: 2px dashed var(--editBtn, #3797fe); */\n  /* padding: 10px 16px; */\n  /* border-radius: 10px; */\n  cursor: pointer;\n  color: var(--editBtn, #3797fe);\n  font-weight: 500;\n  transition: all 0.3s ease;\n  display: inline-flex;\n  align-items: center;\n  /* gap: 0.5rem; */\n  font-size: 0.9rem;\n  /* margin: auto; */\n  /* margin-top: 0.5rem; */\n  justify-content: center;\n  /* min-width: 300px; */\n  border: none;\n}\n\n.addButton:hover:not(:disabled) {\n  transform: translateY(-2px);\n}\n\n.addButton:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none !important;\n  background: #f1f3f4;\n  color: #9aa0a6;\n  border-color: #dadce0;\n}\n\n/* ─── Sample Row ─── */\n.sampleRow {\n  margin-top: 1rem;\n  padding: 16px;\n  background: rgba(126, 112, 206, 0.116);\n  border-radius: 12px;\n  border: 1px solid rgba(163, 112, 206, 0.08);\n  transition: all 0.3s ease;\n  animation: slideIn 0.3s ease;\n}\n\n.sampleRow:hover {\n  background: rgba(163, 112, 206, 0.06);\n  border-color: rgba(163, 112, 206, 0.15);\n}\n\n.sampleStatusGroup {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.75rem;\n}\n\n.sampleStatusGroup .statusInput {\n  width: 120px;\n  flex: none;\n}\n\n.sampleStatusGroup .removeButton {\n  margin-left: auto;\n}\n\n/* ─── Infer Button ─── */\n.inferButtonContainer {\n  display: flex;\n  justify-content: center;\n}\n\n.inferButton {\n  background: var(--editBtn, #3797fe);\n  color: white;\n  padding: 14px 20px;\n  border: none;\n  border-radius: 12px;\n  font-weight: 500;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  display: inline-flex;\n  align-items: center;\n  gap: 0.75rem;\n  box-shadow: 0 4px 16px rgba(55, 151, 254, 0.25);\n  position: relative;\n  overflow: hidden;\n}\n\n.inferButton::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: -100%;\n  right: 0;\n  bottom: 0;\n  background: linear-gradient(\n    90deg,\n    transparent,\n    rgba(255, 255, 255, 0.2),\n    transparent\n  );\n  transition: left 0.5s ease;\n}\n\n.inferButton:hover:not(:disabled)::before {\n  left: 100%;\n}\n\n.inferButton:active:not(:disabled) {\n  transform: translateY(0) scale(0.98);\n}\n\n.inferButton:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n/* ─── Animations ─── */\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateX(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n@keyframes pulse {\n  0%,\n  100% {\n    opacity: 1;\n  }\n  50% {\n    opacity: 0.7;\n  }\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* ─── Responsive ─── */\n@media (max-width: 768px) {\n  .container {\n    padding: 16px;\n    border-radius: 12px;\n  }\n\n  .tabs {\n    flex-wrap: wrap;\n    padding: 0.35rem;\n    gap: 0.25rem;\n  }\n\n  .tab {\n    padding: 0.6rem 0.8rem;\n    font-size: 0.8rem;\n    flex: 1 1 auto;\n    min-width: 80px;\n    gap: 0.35rem;\n  }\n\n  .tab .tabIcon {\n    font-size: 0.95rem;\n  }\n\n  .tabDivider {\n    display: none;\n  }\n\n  .itemRow {\n    flex-wrap: wrap;\n    padding: 12px;\n    flex-direction: column;\n  }\n\n  .itemInput {\n    flex: 1 1 100%;\n    min-width: 0;\n  }\n\n  .sampleStatusGroup {\n    flex-wrap: wrap;\n  }\n\n  .sampleStatusGroup .select,\n  .sampleStatusGroup .statusInput {\n    width: 100%;\n  }\n\n  .selectWrapperSmall {\n    width: 100%;\n  }\n\n  .inferButton {\n    width: 100%;\n    justify-content: center;\n    padding: 12px 20px;\n    font-size: 0.95rem;\n  }\n\n  .addButton {\n    width: 100%;\n    justify-content: center;\n    min-width: auto;\n  }\n    .sampleWrap{\n    flex-direction: column;\n  }\n  .sampleRow{\n    padding: 10px;\n  }\n}\n\n@media (max-width: 480px) {\n  .tabs {\n    flex-direction: column;\n    gap: 0.25rem;\n    padding: 0.25rem;\n  }\n\n  .tab {\n    padding: 0.5rem 1rem;\n    justify-content: center;\n    width: 100%;\n    font-size: 0.75rem;\n  }\n\n  .tab .tabLabel {\n    font-size: 0.8rem;\n  }\n    .sampleWrap{\n    flex-direction: column;\n  }\n}\n\n/* ─── Scrollbar ─── */\n.textarea::-webkit-scrollbar {\n  width: 8px;\n}\n\n.textarea::-webkit-scrollbar-track {\n  background: #f1f1f1;\n  border-radius: 4px;\n}\n\n.textarea::-webkit-scrollbar-thumb {\n  background: var(--editBtn, #3797fe);\n  border-radius: 4px;\n}\n\n.textarea::-webkit-scrollbar-thumb:hover {\n  background: var(--editHover, #0056b3);\n}\n\n/* ─── Focus Visible ─── */\n.input:focus-visible,\n.select:focus-visible,\n.textarea:focus-visible,\n.statusInput:focus-visible,\n.itemInput:focus-visible,\n.addButton:focus-visible,\n.removeButton:focus-visible,\n.inferButton:focus-visible,\n.tab:focus-visible {\n  outline-offset: 2px;\n}\n\n/* ─── Loading State ─── */\n.inferButton.loading {\n  position: relative;\n  color: transparent;\n}\n\n.inferButton.loading::after {\n  content: \"\";\n  position: absolute;\n  width: 20px;\n  height: 20px;\n  border: 3px solid rgba(255, 255, 255, 0.3);\n  border-top-color: var(--white-color);\n  border-radius: 50%;\n  animation: spin 0.8s linear infinite;\n}\n\n/* ─── Helper Text ─── */\n.helperText {\n  font-size: 0.8rem;\n  color: var(--text-color, #6b6b6b);\n  margin-top: 0.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n/* ─── Badges ─── */\n.requiredBadge {\n  display: inline-block;\n  background: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n  font-size: 0.7rem;\n  padding: 2px 8px;\n  border-radius: 12px;\n  font-weight: 600;\n  margin-left: 0.5rem;\n}\n\n.statusIndicator {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  margin-right: 8px;\n  animation: pulse 2s infinite;\n}\n\n.statusIndicator.active {\n  background: #28a745;\n}\n\n.statusIndicator.inactive {\n  background: #dc3545;\n}\n\n.statusIndicator.pending {\n  background: #ff9800;\n}\n\n/* ─── Glass Effect ─── */\n.glassEffect {\n  background: rgba(255, 255, 255, 0.7);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n  border: 1px solid rgba(255, 255, 255, 0.2);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"inferButton": `ApiConfigGB_inferButton__T+V+f`,
	"isReady": `ApiConfigGB_isReady__w32RV`,
	"breathe": `ApiConfigGB_breathe__arLme`,
	"pulseGlow": `ApiConfigGB_pulseGlow__tjQQU`,
	"importButton": `ApiConfigGB_importButton__aeaKp`,
	"isImportReady": `ApiConfigGB_isImportReady__UX-70`,
	"inferButtonContainer": `ApiConfigGB_inferButtonContainer__kKYJG`,
	"container": `ApiConfigGB_container__DEkkt`,
	"tabs": `ApiConfigGB_tabs__Qnc5h`,
	"tab": `ApiConfigGB_tab__jZJV2`,
	"activeTab": `ApiConfigGB_activeTab__beAeX`,
	"tabIcon": `ApiConfigGB_tabIcon__gUT43`,
	"tabDivider": `ApiConfigGB_tabDivider__z4p1T`,
	"formGroup": `ApiConfigGB_formGroup__osW68`,
	"sampleWrap": `ApiConfigGB_sampleWrap__icDVw`,
	"label": `ApiConfigGB_label__w0cX4`,
	"selectWrapper": `ApiConfigGB_selectWrapper__VPZ-X`,
	"selectWrapperSmall": `ApiConfigGB_selectWrapperSmall__ELUJD`,
	"customSelect": `ApiConfigGB_customSelect__mhMIR`,
	"selectIcon": `ApiConfigGB_selectIcon__bZr8G`,
	"selectIconSmall": `ApiConfigGB_selectIconSmall__4HUr9`,
	"select": `ApiConfigGB_select__c4cor`,
	"input": `ApiConfigGB_input__F-Mlw`,
	"textarea": `ApiConfigGB_textarea__7IRDp`,
	"statusInput": `ApiConfigGB_statusInput__vM4Mu`,
	"itemsContainer": `ApiConfigGB_itemsContainer__fw7iH`,
	"itemRow": `ApiConfigGB_itemRow__AmKO7`,
	"slideIn": `ApiConfigGB_slideIn__gOa1B`,
	"itemInput": `ApiConfigGB_itemInput__6uKEg`,
	"removeButton": `ApiConfigGB_removeButton__B5HQp`,
	"addButton": `ApiConfigGB_addButton__MZo7v`,
	"sampleRow": `ApiConfigGB_sampleRow__TtUaF`,
	"sampleStatusGroup": `ApiConfigGB_sampleStatusGroup__pkkgE`,
	"tabLabel": `ApiConfigGB_tabLabel__oz9MM`,
	"loading": `ApiConfigGB_loading__auUR7`,
	"spin": `ApiConfigGB_spin__jGKJd`,
	"helperText": `ApiConfigGB_helperText__0xKtk`,
	"requiredBadge": `ApiConfigGB_requiredBadge__--L56`,
	"statusIndicator": `ApiConfigGB_statusIndicator__3L2+B`,
	"pulse": `ApiConfigGB_pulse__bnPLb`,
	"active": `ApiConfigGB_active__F-7g9`,
	"inactive": `ApiConfigGB_inactive__6o7R-`,
	"pending": `ApiConfigGB_pending__RgZhm`,
	"glassEffect": `ApiConfigGB_glassEffect__kywYd`,
	"breatheWithGlow": `ApiConfigGB_breatheWithGlow__iSAI5`
};
export default ___CSS_LOADER_EXPORT___;
